export function healthResponseTransformer(response: Response) {
  return { isAvalable: response.ok }
}
